import EventBuilder from 'Faster/event/EventBuilder';

export default class OpenEventBuilder extends EventBuilder {
  static TYPE = 'open';
  static REVISION = 0;

  public constructor(isWarm: boolean) {
    super(OpenEventBuilder.TYPE, OpenEventBuilder.REVISION);

    this.dimension('isWarm', isWarm);
  }
}
